import * as React from 'react'
import { IconButton, IconButtonVariantName } from '../IconButton/IconButton'
import classnames from 'classnames'

export type IconButtonProps = {
    name?: string
    size?: 'xsmall' | 'small' | 'medium' | 'large'
    iconSize?: 'xsmall' | 'small' | 'medium' | 'large'
    label?: React.ReactNode
}

export type IconButtonGroupProps = {
    buttons: Array<IconButtonProps & { id: string }>
    onChange?: (id: string) => void
    variant?: IconButtonVariantName
    className?: string
    activeId?: string
}

export const IconButtonGroup: React.FC<IconButtonGroupProps> = ({
    buttons,
    onChange,
    variant = 'group',
    className,
    activeId,
}) => {
    const containerClass = 'flex justify-center'
    return (
        <div className={classnames(containerClass, className)}>
            {buttons.map(
                ({ id, name, size = 'small', iconSize = 'small', label }) => {
                    const isActive = id === activeId
                    const buttonClass = classnames(
                        '[&:not(:first-child)]:rounded-l-0',
                        '[&:not(:last-child)]:rounded-r-0',
                        '[&:not(:last-child)]:border-r-0',
                        {
                            'bg-white': !isActive,
                            'bg-neutral-200': isActive,
                        },
                        label && ['w-auto', 'font-medium', 'text-regular']
                    )

                    return (
                        <IconButton
                            key={id}
                            name={id}
                            icon={name}
                            size={size}
                            iconSize={iconSize}
                            variant={variant}
                            onClick={() => onChange?.(id)}
                            className={classnames(buttonClass, className)}
                        >
                            {label}
                        </IconButton>
                    )
                }
            )}
        </div>
    )
}
